import React from 'react';
import BreadcrumbList from './BreadcrumbList';
import { Breadcrumb } from 'models/interfaces';
import './Breadcrumbs.scss';

interface BreadcrumbsProps {
  breadcrumbs: [Breadcrumb];
}

const Breadcrumbs: React.StatelessComponent<BreadcrumbsProps> = ({ breadcrumbs }) => {
  return breadcrumbs? (
    <div className="container" style={{ padding: '0 2rem 0 2rem' }}>
      <section className="page-utility">
        <nav aria-label="breadcrumb">
          {breadcrumbs && <BreadcrumbList breadcrumbs={breadcrumbs} />}
        </nav>
      </section>
    </div>
  ): null;
};

export default Breadcrumbs;
